import { Button, Input } from "@nextui-org/react";
import { useEffect, useState } from "react";
import { ArrayItems } from "../../customdropdown/dropdownarray";
import {
  BackArrowIcon,
  VisibilityOffIcon,
  VisibilityOnIcon,
} from "@/assets/icons/admin";
import CustomDropdown from "../../customdropdown";
import { useCreateUser, useGetAllRoles } from "@/services/admin.service";
import { toast } from "react-toastify";
import { AdminRegistration } from "@/types";
import "react-toastify/dist/ReactToastify.css";

interface AddNewAccountViewProps {
  onCancel: () => void;
}
const AddAccount = ({ onCancel }: AddNewAccountViewProps) => {
  const [isActiveEnabled, setIsActiveEnabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [username, setUsername] = useState("");
  const [isUsernameValid, setIsUsernameValid] = useState(true);
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [confirmPW, setConfirmPW] = useState("");
  const [role, setRole] = useState<ArrayItems | undefined>();
  const [isConfirmPWValid, setIsConfirmPWValid] = useState(true);

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    if (name === "username") {
      setUsername(value);
      setIsUsernameValid(true);
    } else if (name === "fullname") {
      setFullName(value);
    } else if (name === "password") {
      setPassword(value);
      setIsPasswordValid(true);
    } else if (name === "email") {
      setEmail(value);
      setIsEmailValid(true);
    } else if (name === "confirmPW") {
      setConfirmPW(value);
      setIsConfirmPWValid(true);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSave = () => {
    const isPasswordValid = /^(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(password);
    setIsPasswordValid(isPasswordValid);

    const isEmailValid = /\S+@\S+\.\S+/.test(email);
    setIsEmailValid(isEmailValid);

    const isConfirmPWMatch = password === confirmPW;
    setIsConfirmPWValid(isConfirmPWMatch);
    if (isPasswordValid && isEmailValid && isConfirmPWMatch && role) {
      handleSubmit();
    } else {
      toast.error("All inputs are required!");
    }
  };
  const [selectedRole, setSelectedRole] = useState<string | null>("all");
  const handleDropdownSelect = (selectedOption: ArrayItems | null) => {
    console.log("Selected option:", selectedOption);
    if (selectedOption !== null) {
      setRole(selectedOption);
      setSelectedRole(selectedOption.value);
    }
  };
  const { data: getAllRoles, refetch } = useGetAllRoles({
    page: 1,
    pageSize: 10,
  });
  const accounts = getAllRoles?.data?.data.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));
  const { mutate: createUser } = useCreateUser();

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleSubmit = () => {
    const submitData: AdminRegistration = {
      email: email,
      userName: username,
      fullName: fullName,
      password: password,
      status: isActiveEnabled ? "ACTIVE" : "IN_ACTIVE",
      roleId: role!.value.toString(),
    };

    createUser(submitData, {
      onSuccess: (responseData) => {
        console.log("User created successfully", responseData);
        toast.success("User created successfully");
        setTimeout(() => {
          onCancel();
        }, 1000);
        // navigate('/about-my-application');
      },
      onError: (error: unknown) => {
        // @ts-expect-error Using `any` type for error handling, properties may not exist on `error`.
        console.log("Error creating User", error?.response?.data?.error);
        // @ts-expect-error Using `any` type for error handling, properties may not exist on `error`.
        toast.error(error?.response?.data?.error);
      },
    });
  };

  return (
    <div>
      <div className="font-ubuntu w-full text-center text-2xl font-semibold text-white sm:float-left">
        <span>
          <Button
            isIconOnly
            onClick={onCancel}
            className="transparent-bg float-left ml-[-11px] h-auto w-auto"
          >
            <BackArrowIcon />
          </Button>
          <p className="text-sm sm:float-left sm:text-lg md:text-lg lg:text-lg">
            Add Account
          </p>
        </span>
      </div>
      <div className="flex w-full flex-col gap-2 sm:gap-6">
        {/* form grid */}
        <div className="sm:flex sm:flex-row">
          <div className="mt-1 basis-full sm:mt-2 sm:basis-1/2">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Username
            </label>
            <Input
              name="username"
              value={username}
              onChange={handleInputChange}
              className={`w-full rounded-md sm:w-11/12  ${isUsernameValid ? "input-bg" : "validation"} !cursor-text`}
              classNames={{
                // mainWrapper: ["data-added"],
                input: [],
                inputWrapper: [
                  "w-full",
                  "!cursor-text",
                  "bg-white-5",
                  "text-sm",
                ],
              }}
            ></Input>
            {!isUsernameValid && (
              <p className="validation-txt mt-1 text-sm">
                *Username already used. Try Another one.
              </p>
            )}
          </div>
          <div className="mt-1 basis-full sm:mt-2 sm:basis-1/2">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Fullname
            </label>
            <Input
              onChange={handleInputChange}
              name="fullname"
              className="input-bg w-full sm:w-11/12"
              classNames={{
                inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
              }}
            ></Input>
          </div>
        </div>
        <div className="sm:flex sm:flex-row">
          <div className="mt-1 basis-full sm:mt-0 sm:basis-1/2">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              New Password
            </label>
            <Input
              name="password"
              value={password}
              onChange={handleInputChange}
              type={showPassword ? "text" : "password"}
              className={`w-full rounded-md border border-solid sm:w-11/12 ${isPasswordValid ? "input-bg" : "validation"} !cursor-text`}
              classNames={{
                inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
              }}
              endContent={
                <button
                  className="focus:outline-none"
                  type="button"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityOnIcon />}
                </button>
              }
            ></Input>
            {!isPasswordValid && (
              <p className="validation-txt mt-1 text-sm">
                *Password need to be at least 8 characters, 1 number, 1 capital
                letters, and no special characters
              </p>
            )}
          </div>
          <div className="mt-1 basis-full sm:mt-0 sm:basis-1/2">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Email
            </label>
            <Input
              name="email"
              value={email}
              onChange={handleInputChange}
              className={`w-full rounded-md border border-solid sm:w-11/12 ${isEmailValid ? "input-bg" : "validation"} !cursor-text`}
              classNames={{
                inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
              }}
            ></Input>
            {!isEmailValid && (
              <p className="validation-txt mt-1 text-sm">
                *Email is invalid. Try another email
              </p>
            )}
          </div>
        </div>
        <div className="sm:flex sm:flex-row">
          <div className="mt-1 basis-full sm:mt-0 sm:basis-1/2">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Confirm Password
            </label>
            <Input
              name="confirmPW"
              value={confirmPW}
              onChange={handleInputChange}
              type={showConfirmPassword ? "text" : "password"}
              className={`w-full rounded-md border border-solid sm:w-11/12 ${isConfirmPWValid ? "input-bg" : "validation"} !cursor-text`}
              classNames={{
                inputWrapper: ["!cursor-text", "bg-white-5", "text-sm"],
              }}
              endContent={
                <button
                  className="focus:outline-none"
                  type="button"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityOnIcon />
                  )}
                </button>
              }
            ></Input>
            {!isConfirmPWValid && (
              <p className="validation-txt mt-1 text-sm">
                *The Password doesn’t match. Please try again.
              </p>
            )}
          </div>
          <div className="mt-1 basis-full sm:mt-0 sm:basis-1/2">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Group Privilege
            </label>
            <div className="w-full sm:w-11/12">
              <CustomDropdown
                options={accounts}
                onSelect={handleDropdownSelect}
                placeholder=""
                dropdownHeight="100px"
                value={selectedRole ?? ""}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col gap-6">
        <div className="sm:flex sm:flex-row">
          <div className="mb-10 mt-1 flex basis-full items-center sm:mt-5 sm:basis-1/2">
            <div>
              <h2 className="text-base font-bold text-white">
                INACTIVE / ACTIVE
              </h2>
            </div>
            <div>
              <label
                htmlFor="activestate"
                className="relative ml-[161px] mt-2 inline-flex cursor-pointer items-center sm:ml-5 sm:mt-1"
              >
                <input
                  type="checkbox"
                  id="activestate"
                  className="peer sr-only"
                  checked={isActiveEnabled}
                  onClick={() => {
                    setIsActiveEnabled(!isActiveEnabled);
                  }}
                />
                <div className="peer h-6 w-11 rounded-full bg-gray-600 transition after:absolute after:left-[2px] after:top-0.5 after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white/50 after:transition-transform after:content-[''] peer-checked:bg-[#50FF13] peer-checked:after:translate-x-full"></div>
              </label>
            </div>
          </div>
          <div className="mt-5 w-fit basis-full sm:basis-1/2">
            <div className="float-right sm:mr-12">
              <Button
                onClick={handleSave}
                className="admin-common-button-gradient font-ubuntu w-full rounded-md pl-32 pr-32 text-base font-bold sm:pl-20 sm:pr-20"
              >
                <span className="hidden sm:block">Save</span>
                <span className="sm:hidden">Save Changes</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAccount;
